import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { Persona } from "@funded-here-interface/common/src/constant/enum";

type InviteUserRequest = {
  token: string;
  onBoardingUserType: Persona;
  orgId: number;
  isSpvOrg?: boolean;
};

const inviteUserToOrg = async ({
  token,
  onBoardingUserType,
  orgId,
  isSpvOrg,
}: InviteUserRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/organization/invite-users-to-org`,
      { onBoardingUserType, orgId, isSpvOrg },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default inviteUserToOrg;
